export const GoogleEvents = {
  CONVERSION: 'conversion'
} as const;

export abstract class GoogleAnalyticsService {
  static trackEvent(eventName: typeof GoogleEvents[keyof typeof GoogleEvents], payload?: any) {
    const trackingEnabled = window.FEATURES?.tracking;
    const gtag = (window as any).gtag;
    if (trackingEnabled && gtag) {
      gtag('event', eventName, payload);
    }
  }
}
